module.exports = __webpack_public_path__ + "img/018.b6931f34.png";